let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bETPT")).then(() => parcelRequire('hdK8A'));